import PropTypes from "prop-types";
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
export {
  refType as default
};
//# sourceMappingURL=refType.js.map
